import { gql } from "apollo-boost"

export const CreateNotification = gql`
  mutation CreateNotification($userId: String!, $title: String!, $description: String!, $link: String!, $status: Boolean!, $date: Datetime){
    createNotification( filter: {
      userId: $userId
title: $title
description: $description
link: $link
status: $status
date: $date
    }){
  id
  player
  title
}
  } 
`;

// export const NotificationUser = gql`
// query ($id: ID){
//   user( id: $id ){
//     name
//     notifications(orderBy: id_DESC){
//       id
//       createdAt
//       description
//       link
//       status
//       title
//     }
//   }
// }
// `

export const NotificationUser = gql`
query ($id: ID){
  user( id: $id ){
    name
    notifications{
      id
      createdAt
      description
      link
      status
      title
    }
  }
}
`

export const ReadNotification = gql `
mutation ReadNotification($id: ID!){
  updateNotification( filter: {
    id: $id,
    status: true
  }){
    id
    date
    description
    link
    status
    title
  }
}
`